import globalFilter from '../../../tools/globalFilter'

export default function (state, payload) {
  let selectedAusbildungsjahre = payload.selectedItems
  return {
    ...state,
    selectedAusbildungsjahre: selectedAusbildungsjahre,
  }
}
